<template>
	<div class="animated fadeIn">
		<div class="row">


			<!-- LIST DATA  -->
			<div class="col col-12" v-show="tabActivePos === 1">
				<template>
					<ag-grid-vue style="height: 380px"
						class="ag-theme-balham"
						:columnDefs="columnDefs"
						:gridOptions="gridOptions"
						:defaultColDef="defaultColDef"
						@grid-ready="onGridReady"
						@cell-focused="CellFocused"
						@cell-value-changed="cellValueChanged"
						:columnTypes="columnTypes"
						:rowSelection="rowSelection"
						:components="components"
						:pagination="true"
						:rowData="rowData">
					</ag-grid-vue>


					<add-field
						:field=new_field
						@addField="insertField"
					/>
				</template>
			</div>
			
			<!-- /LIST DATA -->
		</div>
		<b-modal
			title="Confirm"
			class="modal-primary"
			v-model="deleteModal"
			@ok="deleteRecords()"
		>Do you really need to delete {{ selectedRows.length }} records?</b-modal>

		<b-modal
			title="Edit location"
			class="modal-primary"
			v-model="editLocationModal"
			@ok="updateLocation()"
		>
			<GeoLocation
				:lng="locationLng"
				:lat="locationLat"
				@onChangeMarker="(e) => setLocationValues(e)"
			></GeoLocation>
		</b-modal>

		<b-modal
			title="Edit image"
			class="modal-primary"
			v-model="editImageModal"
			@ok="updateImage()"
		>
			<image-uploader
				ref="image"
				validate="required"
				:placeholder="columnToUpdate"
				@imageSelected="data => valueToUpdate = data.dataURI"
				@linkChanged="link => valueToUpdate = link"
				:file-name="fileName"
			>
			</image-uploader>
			<img :src="valueToUpdate" style="width: 100%">
		</b-modal>
	</div>
</template>

<script>
	import GeoLocation from './GeoLocation'
	// import InputTag from 'vue-input-tag'
	import ImageUploader from './ImageUploader'
	import addField from './addFieldToDataset'
	import axios from 'axios'
	import { AgGridVue } from 'ag-grid-vue';
	import _ from 'lodash';
	import {gmapApi} from 'vue2-google-maps'

	export default {
		name: 'data-set',
		props: ['type'],
		components: {
			ImageUploader,
			// InputTag,
			GeoLocation,
			AgGridVue,
			addField
		},
		data() {
			return {
				tabs: ['new item', 'list'],
				tabActivePos: 1,
				records: [],
				record_id: 0,
				columns: [],
				page: 1,
				pagination_bar: [],
				deleteModal: false,
				active_element_id: -1,
				active_mode: 'add',
				active_element_name: '',
				singleRecord: {},
				schema: [],
				ds_name: '',
				env: process.env,
				exceptFields: ['ds_id', '__user_id', '_id'],
				exceptValidationFields: ['tags', 'subtitle'],
				constantFields: ['title', 'subtitle', 'price', 'image'],
				fileName: '',
				columnDefs: null,
				rowData: null,
				gridApi: null,
				gridColumnApi: null,
				defaultColDef: null,
				columnTypes: null,
				gridOptions: {},
				api: null,
				rowSelection: 'multiple',
				selectedRows: [],
				components: { 
					numericCellEditor: this.getNumericCellEditor(),
				},
				editLocationModal: false,
				editImageModal: false,
				locationLng: null,
				locationLat: null,
				rowToUpdate: {},
				valueToUpdate: null,
				columnToUpdate: null,
				new_field: {
					name: null,
					type: null,
					permission: 'rw'
				},
				imagesFields: [],
				locationsFields: [],
				images: [],
				locations: [],
				indexToUpdate: null,
				// totalItems: 0,
				// totalPages: 0
			}
		},

		methods: {
			onGridReady(params) {
				this.api = params.api;
				this.agGrid(this.page)
			},

			getLabel(tab) {
				if (tab === 'new item' && this.active_mode === 'save' && this.active_element_id != -1) {
					return 'edit item'
				}
				return tab
			},

			init() {
				this.active_element_id = -1
				this.active_mode = 'add'
				this.singleRecord = {}

				var _i,
					element
					// image = this.$refs.image

				for (_i = 0; _i < this.columns.length; _i++) {
					element = this.columns[_i]
					this.singleRecord[element.name] = element.value
				}

				this.singleRecord['_id'] = ''
				this.singleRecord['ds_id'] = this.record_id
				this.singleRecord['__user_id'] = ''

				// image && image[0].rebuild()

				this.$root.loader = false
			},

			formatRecord(record) {
				for (var item in this.schema) {
					var name = this.schema[item].name
					var type = this.schema[item].type
					if (record[name] !== undefined) {
						if (type === 'text') {
							record[name] = (record[name] || '').toString()
						} else if (type === 'number') {
							record[name] = parseFloat(record[name])
						}
					}
				}
				return record
			},

			handleOnAddRecord(res) {
				this.singleRecord['_id'] = res.data._id
				this.records.push(this.singleRecord)

				this.$root.notify({
					message: this.$t('successfully added'),
					status: 'success',
					area: 'topRight',
				})
			},

			handleOnEditRecord(res) {
				this.singleRecord['_id'] = res.data._id
				var temp = []
				for (var i = 0; i < this.records.length; i++) {
					if (this.records[i]['_id'] === this.active_element_id) {
						temp.push(this.singleRecord)
					} else {
						temp.push(this.records[i])
					}
				}
				this.records = temp

				this.$root.notify({
					message: this.$t('successfully updated'),
					status: 'success',
					area: 'topRight',
				})
			},

			validateForm() {
				return new Promise((resolve) => {
					const fields = Array.from(Object.keys(this.singleRecord)).filter(
						(e) => this.exceptValidationFields.indexOf(e) === -1 && this.constantFields.indexOf(e) >= 0
					)

					this.validateImage().then((status) => {
						if (fields.length && this.type === 'menu') {
							this.$validator.validateAll(fields).then((state) => resolve(status && state))
						} else {
							resolve(status && true)
						}
					})
				})
			},

			validateImage() {
				return this.$refs.image ? this.$refs.image[0].$validator.validateAll() : Promise.resolve(true)
			},

			cellValueChanged (event) {
				axios.post('/dataset/update-dataset/', {data: event.data})
				.then((res) => {
					if (res.data.status) {
						if (res.data._id) {
							var insertedItem = this.rowData[this.rowData.length - 1];
							var ds_id = insertedItem.ds_id;
							insertedItem._id = res.data._id;
							this.rowData.push({
								ds_id: ds_id
							})
						}

						if (res.data.image) {
							this.rowToUpdate[this.columnToUpdate] = res.data.image;

							this.gridOptions.api.updateRowData({ update: [this.rowToUpdate] });
							this.rowToUpdate = {};
						}
					}
					this.$root.loader = false
				})
			},

			agGrid() {
				this.$root.loader = true;
				this.defaultColDef = {
					resizable: true,
					flex: 1,
					// type: 'valueColumn',
					editable: true
				};
				this.columnTypes = {
					valueColumn: {
						// valueParser: "alert(oldValue)",
					}
				};
				return axios
					.post('/dataset/get-with-keys', {keywords: this.keywords, ds_id: this.record_id, page: this.page})
					.then((res) => {
						if (res.data.status) {
							res.data.data.header.forEach(function(field, i) {
								if (field.type == 'image') {									
									res.data.data.header[i].cellRenderer = param => {
										var imgURL;
										if (this.validURL(param.value)) {
											imgURL = param.value;
										} else {
											imgURL = this.getFullUrl(param.value);
										}

										if (imgURL) {
											return `<img src="${this.getResizedImage(imgURL)}">`;
										}
										return '';
									}
									this.imagesFields.push(field.field);
								} else if (field.type == 'location') {
									this.locationsFields.push(field.field);
								}
							}.bind(this));
							
							this.columnDefs = res.data.data.header

							for (let i = 0; i < res.data.data.body.length; i++) {
								for (let j = 0; j < this.locationsFields.length; j++) {
									
									const locationField = this.locationsFields[j];
									console.log(res.data.data.body[i][locationField]);
									if (res.data.data.body[i].hasOwnProperty(locationField)) {
										this.locations[i] = res.data.data.body[i][locationField];
										res.data.data.body[i][locationField] = res.data.data.body[i][locationField].address || 'Location';
									}
								}
								for (let j = 0; j < this.imagesFields.length; j++) {
									let imageField = this.imagesFields[j];
									
									this.images[i] = res.data.data.body[i][imageField];
								}
							}
							this.rowData = res.data.data.body;
							// this.totalItems = res.data.data.totalItems;
							// this.totalPages = res.data.data.totalPages;
						}
						this.$root.loader = false;
					})
			},

			save() {
				this.validateForm().then((status) => {
					if (status === true) {
						this.singleRecord = this.formatRecord(this.singleRecord)
						const mode = this.active_mode
						const data = {record: this.singleRecord, schema: this.schema}
						const url = '/dataset/insert_data'
						this.$root.loader = true
						axios.post(url, data).then((res) => {
							if (res.data.status) {
								if (mode == 'add') this.handleOnAddRecord(res)
								else this.handleOnEditRecord(res)
								setTimeout(this.init, 1000)
							}
						})
					}
				})
			},

			// Deprecated
			deleteRecord(record, alarm) {
				if (alarm) {
					this.deleteModal = true
					this.active_element_id = record['_id']
				} else {
					if (this.active_element_id != -1) {
						this.$root.loader = true
						axios.post('/dataset/delete_data', {_id: this.active_element_id}).then((res) => {
							if (res.data.status == 1) {
								var temp = []
								var _id = res.data._id
								for (var i = 0; i < this.records.length; i++) {
									if (this.records[i]['_id'] != _id) {
										temp.push(this.records[i])
									}
								}
								this.records = temp
								setTimeout(this.init, 1000)
							}
							this.$root.loader = false
						})
					}
				}
			},

			// handleOnChangeMarker(latLng, fieldName) {
			// 	if (this.singleRecord.hasOwnProperty(fieldName)) {
			// 		this.singleRecord[fieldName] = {
			// 			type: 'Point',
			// 			coordinates: [latLng.lng, latLng.lat],
			// 		}
			// 		this.singleRecord = {...this.singleRecord}
			// 	}
			// },

			// Utilities
			isText(name) {
				return !!this.mapShema((element) => element.name.toString() == name.toString() && element.type === 'text')
			},
			isNumber(name) {
				return !!this.mapShema((element) => element.name.toString() == name.toString() && element.type === 'number')
			},
			isList(name) {
				return !!this.mapShema((element) => element.name.toString() == name.toString() && element.type === 'list')
			},
			isLocation(name) {
				return !!this.mapShema(
					(element) => element.name.toString() == name.toString() && element.type === 'location'
				)
			},
			mapShema(callback) {
				let index, element
				for (index = 0; index < this.schema.length; index++) {
					element = this.schema[index]
					if (callback(element)) {
						return element
					}
				}
				return false
			},

			deleteRecords() {
				this.$root.loader = true;
				axios.post('/dataset/multiple-delete-data', {ids: _.map(this.selectedRows, '_id')}).then((res) => {
					if (res.data.status == 1) {
						this.gridOptions.api.updateRowData({ remove: this.selectedRows });
						this.selectedRows = [];
					}
					this.$root.loader = false;
				})
			},
			
			addColumn(column) {
				var columnDefs = this.gridOptions.columnDefs;
				var newColumn = { 
					field: column.name,
					type: column.type,
					permission: column.permission,
				};

				if (column.type == 'text') {
					newColumn.cellEditor = 'agLargeTextCellEditor'
				} else if (column.type == 'number') {
					newColumn.cellEditor = 'numericCellEditor'
				}
				columnDefs.push(newColumn);
				this.gridOptions.api.setColumnDefs(columnDefs);
			},

			getNumericCellEditor() {
				function isCharNumeric(charStr) {
					return !!/\d/.test(charStr);
				}
				function isKeyPressedNumeric(event) {
					var charCode = getCharCodeFromEvent(event);
					var charStr = String.fromCharCode(charCode);
					return isCharNumeric(charStr);
				}
				function getCharCodeFromEvent(event) {
					event = event || window.event;
					return typeof event.which === "undefined" ? event.keyCode : event.which;
				}
				function NumericCellEditor() {}
				NumericCellEditor.prototype.init = function(params) {
					this.focusAfterAttached = params.cellStartedEdit;
					this.eInput = document.createElement("input");
					this.eInput.style.width = "100%";
					this.eInput.style.height = "100%";
					this.eInput.value = isCharNumeric(params.charPress) ? params.charPress : params.value;
					var that = this;
					this.eInput.addEventListener("keypress", function(event) {
					if (!isKeyPressedNumeric(event)) {
						that.eInput.focus();
						if (event.preventDefault) event.preventDefault();
					}
					});
				};
				NumericCellEditor.prototype.getGui = function() {
					return this.eInput;
				};
				NumericCellEditor.prototype.afterGuiAttached = function() {
					if (this.focusAfterAttached) {
					this.eInput.focus();
					this.eInput.select();
					}
				};
				NumericCellEditor.prototype.isCancelBeforeStart = function() {
					return this.cancelBeforeStart;
				};
				NumericCellEditor.prototype.isCancelAfterEnd = function() {};
				NumericCellEditor.prototype.getValue = function() {
					return this.eInput.value;
				};
				NumericCellEditor.prototype.focusIn = function() {
					var eInput = this.getGui();
					eInput.focus();
					eInput.select();
					console.log("NumericCellEditor.focusIn()");
				};
				NumericCellEditor.prototype.focusOut = function() {
					console.log("NumericCellEditor.focusOut()");
				};
				return NumericCellEditor;
			},

			CellFocused(data) {
				if (data.column != undefined) {
					if (data.column.userProvidedColDef.type == 'location') {
						this.rowToUpdate = this.api.getRowNode(data.rowIndex).data;
						this.columnToUpdate = data.column.userProvidedColDef.field;
						this.valueToUpdate = this.locations[data.rowIndex];
						this.indexToUpdate = data.rowIndex;

						if (this.valueToUpdate != undefined) {
							if (this.valueToUpdate.coordinates != undefined) {
								if (this.valueToUpdate.coordinates.length == 2) {
									this.locationLng = this.valueToUpdate.coordinates[0];
									this.locationLat = this.valueToUpdate.coordinates[1];
								}
							}
						}

						this.editLocationModal = true
					} else if (data.column.userProvidedColDef.type == 'image') {
						this.rowToUpdate = this.api.getRowNode(data.rowIndex).data;
						this.columnToUpdate = data.column.userProvidedColDef.field;
						this.indexToUpdate = data.rowIndex;
						// this.valueToUpdate = this.rowToUpdate[this.columnToUpdate] || ''
						this.valueToUpdate = this.images[data.rowIndex];

						this.editImageModal = true;
					}
				}
			},

			async updateLocation() {
				var formatedAddress = await this.getGeoCode(this.locationLng, this.locationLat)

				var newValue = {
					type: 'Point',
					coordinates: [this.locationLng, this.locationLat],
					address: formatedAddress
				}

				this.rowToUpdate[this.columnToUpdate] = newValue;

				var newData = this.rowToUpdate;

				this.cellValueChanged({
					data: newData
				});


				this.locations[this.indexToUpdate] = newValue
				// this.gridOptions.api.updateRowData({ update: [this.rowToUpdate] });

				
				this.rowToUpdate = {};
				this.columnToUpdate = null;
				this.locationLat = null;
				this.locationLng = null;

			},

			setLocationValues(e) {
				this.locationLng = e.lng;
				this.locationLat = e.lat;
			},

			updateImage() {
				var newValue = this.valueToUpdate;
				this.images[this.indexToUpdate] = newValue

				this.rowToUpdate[this.columnToUpdate] = newValue;

				this.cellValueChanged({
					data: this.rowToUpdate
				});

				// this.gridOptions.api.updateRowData({ update: [this.rowToUpdate] });
				
				// this.rowToUpdate = {};
				// this.columnToUpdate = null;
			},

			insertField() {
				if (this.new_field.name && this.new_field.type) {
					if (this.checkExistFieldName(this.new_field.name)) {
						this.$root.notify({
							message: `${this.new_field.name} field is exist`,
							status: 'info',
							area: 'topRight',
							timeLeft: 0,
						})
					} else {
						this.$root.loader = true;
						axios.post(`/dataset/add-field/${this.record_id}`, {data: this.new_field})
						.then((res) => {
							if (res.data.status) {
								this.addColumn(this.new_field);
							}
							this.$root.loader = false;
							this.new_field.name = '';
						})
					}
				} else {
					this.$root.notify({
						message: `Missing data`,
						status: 'info',
						area: 'topRight',
						timeLeft: 0,
					})
				}
			},

			checkExistFieldName(name) {
				for (let i = 0; i < this.columnDefs.length; i++) {
					let col = this.columnDefs[i];
					if (col.field == name) {						
						return true;
					}
				}

				return false;
			},

			goToPage(page) {
				this.locations = [];
				this.locationsFields = [];
				this.images = [];
				this.imagesFields = [];
				this.page = page;
				this.agGrid();
			},

			validURL(str) {
				var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
					'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
					'((\\d{1,3}\\.){3}\\d{1,3}))'); // fragment locator
				return !!pattern.test(str);
			},

			getFullUrl(path) {
				if (path) {
					var baseUrl = process.env.VUE_APP_SERVER_URL.replace(/\/?$/, ""); // trim the last slash `if exists`
					path = path.replace(/^\//, ""); // trim the first slash `if exists`
					return `${baseUrl}/public/${path}`;
				}
			},

			getResizedImage(img, width = 50, height = 50) {
				if (img) {
					return `https://imgcdn.smartlytechs.com/unsafe/fit-in/${width}x${height}/${img}`;
				}
			},

			getGeoCode(lng, lat) {
				var g = new this.google.maps.Geocoder

				return new Promise(resolve => {
					g.geocode({'location': {lat, lng}}, (results, status) => {
						if (status === 'OK') {
							resolve(results[0].formatted_address)
						}
					})
				});
			}
		},
		beforeMount() {
			this.record_id = parseInt(this.$route.params.id);
			if (parseInt(this.$route.params.page) >= 1) {
				this.page = parseInt(this.$route.params.page)
			}
		},
		mounted() {
			// get dataset schema
			// this.fetchDatasetSchema(parseInt(this.$route.params.id), () => {
			// 	this.paginateTo(this.page).then(() => {
			// 		this.init()
			// 	})
			// })


			this.gridOptions.api.paginationSetPageSize(10);

			window.addEventListener('keyup', (ev) => {
				if (ev.keyCode == 46) {
					this.selectedRows = this.gridOptions.api.getSelectedRows();
					if (this.selectedRows.length) {
						this.deleteModal = true;
					}
				}
			});
		},

		computed: {
			google: gmapApi
		}
	}
</script>
<style lang="scss">
    @import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
    @import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>